import { Component, Input } from '@angular/core';
import {
  heartIcon,
  UIKitIconRegistry,
} from '@ui-kit';

@Component({
  selector: 'app-perk',
  templateUrl: './perk.component.html',
  styleUrls: ['./perk.component.scss'],
})
export class PerkComponent {
  @Input() preview: string;

  @Input() logo: string;

  @Input() text: string;

  @Input() retailerLink: string;

  @Input() claimLink: string;

  @Input() isNew: boolean = true;

  @Input() logoWidth: string = '100%';

  constructor(private iconRegistry: UIKitIconRegistry) {
    iconRegistry.registerIcons([
      heartIcon,
    ]);
  }
}
